
// region JS Imports

// region External Modules
import Promise from "bluebird"
// endregion External Modules

// region Private Modules
import {
  q_ajax_3,
  ERROR_HANDLER_ACTIONS as AJAX_ERROR_HANDLER_ACTIONS,
} from "app/utils/q_ajax/q_ajax_3"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


/* eslint-disable no-unused-vars */
enum ResultTypeEnums {
  SUCCESS =          "SUCCESS",
  NOT_SIGNED_IN =    "NOT_SIGNED_IN",
  INVALID =          "INVALID",
  SERVER_ERROR =     "SERVER_ERROR",
  TOO_MANY_REQUEST = "TOO_MANY_REQUEST",
}
/* eslint-enable no-unused-vars */

interface ColivingSpaceEntryDataEntry {
  id: string,
}

interface PromiseResolvePayload {
  result_type: ResultTypeEnums,
  data?: ColivingSpaceEntryDataEntry[],
}

const get_many = () => {
  return Promise.resolve()
  .then(() => {
    return q_ajax_3(
      {
        url:      "/api/web_app/current_authenticated_user/coliving_space_entries_shortlisted",
        method:   "GET",
        dataType: "json",
      },
      {
        custom_error_handler: ({http_status_code}) => {
          if (http_status_code === 401) {
            return AJAX_ERROR_HANDLER_ACTIONS.STOP_RETRY
          }

          return AJAX_ERROR_HANDLER_ACTIONS.CONTINUE_RETRY
        },
        error_tracking_options: {
          endpoint_identifier: "/api/web_app/current_authenticated_user/coliving_space_entries_shortlisted",
        },
      },
    )
  })
  .then(({data}: {
    data: {
      data: {
        coliving_space_entries: ColivingSpaceEntryDataEntry[]
      }
    }
  }): PromiseResolvePayload => {
    return (
      {
        result_type: ResultTypeEnums.SUCCESS,
        data:        data.data.coliving_space_entries,
      }
    )
  })
  .catch((reason_or_error): PromiseResolvePayload => {
    if (reason_or_error instanceof Error) {
      throw reason_or_error
    }

    const { response } = reason_or_error
    switch (response.status) {
      case 500:
      case 502:
      case 503:
      case 504:
        return ({result_type: ResultTypeEnums.SERVER_ERROR})
      case 401:
        return ({result_type: ResultTypeEnums.NOT_SIGNED_IN})
      case 429:
        return ({result_type: ResultTypeEnums.TOO_MANY_REQUEST})
      default:
        return ({result_type: ResultTypeEnums.INVALID})
    }
  })
}

export {
  get_many,
  ResultTypeEnums,
}
